
if ($('.management-details-sidebar-links').length > 0) {
    
    let currentPageId = $('.management-details-sidebar-links').attr("data-current-page-id");
    $('[data-page-id =' + currentPageId + ']').addClass('-active');
    console.log('here');
    let currentPosition = $('[data-page-id =' + currentPageId + '] .management-details-sidebar-links__position').text();
    $('.management-details-sidebar-links__mobile-btn').text(currentPosition);
}
